<template>
    <div>
        <svg ref="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"/>
    </div>
</template>

<script>
export default {
    name: 'Ball',
    props:['primary_color','type','secondary_color','number'],
    mounted(){
        // draw the ball
        this.draw();
    },
    watch: {
        'primary_color': function(){
            this.draw();
        },
        'type': function(){
            this.draw();
        },
        'secondary_color': function(){
            this.draw();
        },
        'number': function(){
            this.draw();
        },                        
    },
    methods: {
        /**
         * Method that draw all the styles in the circle of the svg
         */
        draw(){
            // remove svg childs
            while (this.$refs.svg.firstChild) {
                this.$refs.svg.removeChild(this.$refs.svg.firstChild);
            }
            // create circle element
            var circle = document.createElementNS("http://www.w3.org/2000/svg","circle");
            circle.setAttribute("cx",100);
            circle.setAttribute("cy",100);
            circle.setAttribute("r",50);
            circle.setAttribute("fill",this.primary_color ? this.primary_color : '#FFFFFF');
            circle.setAttribute("stroke",this.secondary_color != '' ? this.secondary_color : "#000000");
            // append into svg elemtn the circle
            this.$refs.svg.appendChild(circle);
             // check if ball has a type, check if primary color is not the same as the second and if isset the second color
             if(this.type != '' && this.primary_color != this.secondary_color && this.secondary_color != ''){

                 switch(this.type){
                    
                    case "horizontal_stripes":
                        // top
                        var polygon = this.drawPolygon("71,60 58,74 129,60 142,74 71,60 129,60 58,74 142,74");
                        polygon.setAttribute("stroke-width","2.3");
                        this.$refs.svg.appendChild(polygon);
                        // middle
                        var polygon = this.drawPolygon("51,93 51,107 149,93 149,107 51,93 149,93 51,107 149,107");
                        polygon.setAttribute("stroke-width","2.1");
                        this.$refs.svg.appendChild(polygon);
                        // bottom
                        var polygon = this.drawPolygon("58,126 71,140 142,126 129,140 58,126 142,126 71,140 129,140")
                        polygon.setAttribute("stroke-width","2.3");
                        this.$refs.svg.appendChild(polygon);
                    break;
                    case "vertical_stripes":
                        // left
                        var polygon = this.drawPolygon("60,71 74,58 60,129 74,142 60,71 60,129 74,58 74,142")
                        polygon.setAttribute("stroke-width","2.3");
                        this.$refs.svg.appendChild(polygon);
                        // middle
                        var polygon = this.drawPolygon("93,51 107,51 93,149 107,149 93,51 93,149 107,51 107,149")
                        polygon.setAttribute("stroke-width","2.1");
                        this.$refs.svg.appendChild(polygon);
                        // right
                        var polygon = this.drawPolygon("126,58 140,71 126,142 140,129 126,58 126,142 140,71 140,129");
                        polygon.setAttribute("stroke-width","2.3");
                        this.$refs.svg.appendChild(polygon);

                    break;
                    case "diagonal_strip":
                        // left
                        var polygon = this.drawPolygon("60,71 74,58 60,129 74,142 60,71 60,129 74,58 74,142");
                        polygon.setAttribute("stroke-width","2.3");
                        polygon.setAttribute("transform","rotate(45 100 100)");
                        this.$refs.svg.appendChild(polygon);
                        // middle
                        var polygon = this.drawPolygon("93,51 107,51 93,149 107,149 93,51 93,149 107,51 107,149");
                        polygon.setAttribute("stroke-width","2.1");
                        polygon.setAttribute("transform","rotate(45 100 100)");
                        this.$refs.svg.appendChild(polygon);
                        // right
                        var polygon = this.drawPolygon("126,58 140,71 126,142 140,129 126,58 126,142 140,71 140,129");
                        polygon.setAttribute("stroke-width","2.3");
                        polygon.setAttribute("transform","rotate(45 100 100)");
                        this.$refs.svg.appendChild(polygon);
                    break;
                    case "inverted_chevron":
                        // left
                        var polygon = this.drawPolygon("93,149 107,149 93,107 107,98 93,149 93,107 107,149 107,98")
                        polygon.setAttribute("stroke-width","2.1");
                        polygon.setAttribute("transform","rotate(135 100 100)");
                        this.$refs.svg.appendChild(polygon);
                        // right
                        var polygon = this.drawPolygon("93,51 107,51 93,107 107,107 93,51 93,107 107,51 107,107");
                        polygon.setAttribute("stroke-width","2.1");
                        polygon.setAttribute("transform","rotate(45 100 100)");
                        this.$refs.svg.appendChild(polygon);
                    break;        

                 }
            }
            // check for a valid number
            if(this.number > 0 && this.number < 100){  
                var text = document.createElementNS("http://www.w3.org/2000/svg","text");
                text.setAttribute("x",this.number < 10 ? "75" : "65");
                text.setAttribute("y",this.number < 10 ? "130" : "125");
                // text.setAttribute("fill","white");
                // text.setAttribute("stroke","black");
                // text.setAttribute("font-size", this.number < 10 ? "100" : "75");
                text.setAttribute("style","fill : white; stroke : black; font-size : " + (this.number < 10 ? "100" : "75" ) + "; text-align: center; font-family: Times New Roman");
                text.textContent = this.number;
                this.$refs.svg.appendChild(text);    
            }
        },
        drawPolygon(points){
            var polygon = document.createElementNS("http://www.w3.org/2000/svg","polygon");
            polygon.setAttribute("points",points);
            polygon.setAttribute("fill",this.secondary_color ? this.secondary_color : '#000000');
            polygon.setAttribute("stroke",this.secondary_color ? this.secondary_color : '#000000');
            polygon.setAttribute("stroke-linejoin","round");
            return polygon;
        }
    }
}
</script>

<style lang="scss" scoped>
    svg {
        height: 160px;
    }
</style>